/* ============================================================
   Flaire deferred-media + hero-priority helper
   PERF FIX F/G/H (Sep 2026)

   F. Hero image priority.
      The old version ran synchronously in <head> and installed a
      MutationObserver on document.documentElement with subtree:true for the
      first 500ms, so it fired on essentially every node inserted while a
      ~970KB document was parsed. The native hero section now sets
      fetchpriority itself, so this only needs to catch app-injected heroes,
      once, after parsing.

   G. Below-the-fold video.
      autoplay OVERRIDES preload="none": a browser starts downloading an
      autoplaying video immediately regardless of the preload hint. Any
      autoplaying video that starts below the first screen has its source
      detached until it is actually scrolled near.

   H. Video inside <template>.
      The Section Store product-video section renders each clip twice inside a
      <template>: once with a real src + autoplay, once as a .lazy copy with
      data-src. Template content is inert, so nothing downloads until the
      section's own script clones it into the page - at which point all of the
      eager copies start downloading at once (~29MB on the homepage). That
      section is licensed vendor code and is deliberately NOT edited here.
      Instead we rewrite the template's inert content before it is cloned,
      converting src -> data-src + class="lazy" so the clips ride the same
      lazy path the section already uses for its other copies.
      This runs at script execution time (defer, i.e. after parsing but before
      DOMContentLoaded) so it lands ahead of the section's cloning.
   ============================================================ */
(function () {
  var HERO_SELECTORS = [
    '[class*="aigenblock"] img',
    '[class*="ai-hero-image"] img',
    '[class*="ai-hero"] img',
    '.banner__media img',
    '.slideshow__media img'
  ].join(',');

  function applyEager() {
    var img = document.querySelector(HERO_SELECTORS);
    if (!img) return;
    img.setAttribute('loading', 'eager');
    img.setAttribute('fetchpriority', 'high');
    var src = img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-lazy-src');
    if (src && !img.complete) {
      img.removeAttribute('data-src');
      img.removeAttribute('data-lazy-src');
      img.setAttribute('src', src);
    }
  }

  function makeLazy(video) {
    var direct = video.getAttribute('src');
    if (direct) {
      video.setAttribute('data-src', direct);
      video.removeAttribute('src');
    }
    var sources = video.querySelectorAll('source[src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('data-src', sources[i].getAttribute('src'));
      sources[i].removeAttribute('src');
    }
    video.setAttribute('preload', 'none');
    if (video.className.indexOf('lazy') === -1) {
      video.className = (video.className + ' lazy').trim();
    }
  }

  /* PERF FIX H - defuse eager <video src> inside inert <template> markup. */
  function disarmTemplates() {
    var templates = document.querySelectorAll('template');
    for (var t = 0; t < templates.length; t++) {
      var content = templates[t].content;
      if (!content) continue;
      var videos = content.querySelectorAll('video[src], video source[src]');
      for (var v = 0; v < videos.length; v++) {
        var node = videos[v];
        var video = node.tagName === 'VIDEO' ? node : node.parentNode;
        if (video) makeLazy(video);
      }
    }
  }

  function activate(video) {
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
    }
    var deferred = video.getAttribute('data-deferred-src') || video.getAttribute('data-src');
    if (deferred) {
      video.src = deferred;
      video.removeAttribute('data-deferred-src');
    }
    video.setAttribute('preload', 'metadata');
    video.load();
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  }

  function detach(video) {
    if (video.getAttribute('data-fr-deferred')) return false;
    video.setAttribute('data-fr-deferred', '1');
    video.removeAttribute('autoplay');
    video.autoplay = false;
    var direct = video.getAttribute('src');
    if (direct) {
      video.setAttribute('data-deferred-src', direct);
      video.removeAttribute('src');
    }
    var sources = video.querySelectorAll('source[src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('data-src', sources[i].getAttribute('src'));
      sources[i].removeAttribute('src');
    }
    video.setAttribute('preload', 'none');
    video.load();
    return true;
  }

  var observer = null;

  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          observer.unobserve(entries[i].target);
          activate(entries[i].target);
        }
      }
    }, { rootMargin: '300px 0px' });
    return observer;
  }

  function initVideos() {
    var io = getObserver();
    if (!io) return;

    var lazy = document.querySelectorAll('video[data-autoplay-lazy], video[data-src]');
    for (var i = 0; i < lazy.length; i++) io.observe(lazy[i]);

    var firstScreen = window.innerHeight * 1.25;
    var eager = document.querySelectorAll('video[autoplay]');
    for (var j = 0; j < eager.length; j++) {
      var video = eager[j];
      var hasSource = video.getAttribute('src') || video.querySelector('source[src]');
      if (!hasSource) continue;
      if (video.getBoundingClientRect().top < firstScreen) continue;
      if (detach(video)) io.observe(video);
    }
  }

  /* Runs at defer-execution time: parsing is done, DOMContentLoaded has not
     fired, and the video section has not cloned its templates yet. */
  disarmTemplates();

  function init() {
    disarmTemplates();
    applyEager();
    initVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
